import React from 'react';
import { FormInstance } from 'antd/lib/form';
import SpaceDescriptions from '../../../../common/Layout/SpaceDescriptions';
import AppDivider from '../../../../common/AppDivider';

export type CreateGarbdPreviewProps = {
    form: FormInstance;
};

export default CreateGarbdPreview;

function CreateGarbdPreview({ form }: CreateGarbdPreviewProps) {
    const { garbdConfig } = form.getFieldsValue(true);
    const [address] = garbdConfig.address || [];
    return (
        <div>
            <SpaceDescriptions
                direction="vertical"
                title="Configuration"
                size="small"
                alignItems="right"
            >
                <SpaceDescriptions.Item label="Server Address" labelStrong>
                    {address?.extraData.hostname ?? ''}
                </SpaceDescriptions.Item>
                <SpaceDescriptions.Item label="CmdLine" labelStrong>
                    {garbdConfig.cmdline ?? ''}
                </SpaceDescriptions.Item>
                <SpaceDescriptions.Item label="Firewall" labelStrong>
                    {`${garbdConfig.firewall ?? ''}`}
                </SpaceDescriptions.Item>
                <SpaceDescriptions.Item label="AppArmor/SELinux" labelStrong>
                    {`${garbdConfig.appArmor ?? ''}`}
                </SpaceDescriptions.Item>
            </SpaceDescriptions>
            <AppDivider />
        </div>
    );
}
